import { defaultToolTip } from '@components/charts/config';
import { result } from 'lodash-es';

const sortRawTableData = (rawTableData) => {
  const indexOfName = (nameList, parent) => nameList.indexOf(parent);
  const nameList = [];
  rawTableData.forEach((element) => {
    nameList.push(element.name);
  });
  const compareFn = (a, b) =>
    indexOfName(nameList, a.parent) < indexOfName(nameList, b.parent) ? -1 : 1;
  return [...rawTableData].sort(compareFn);
};

const getAllChildLine = (rawTableData, rawTableDataTargetLine) =>
  rawTableData.filter((d) => d.parent === rawTableDataTargetLine.name);

class Node {
  id;
  charttype;
  type;
  name;
  title;
  level;
  parent;

  color;
  height = 50;
  width = 300;
  offset = 0;

  normalTreeLevel = 1;
  verticalOrgMemberListlevel = 1;

  parentNode;
  childNodeList = [];

  constructor(sortedRawTableData, rawTableDataTargetLine, parentNode = null) {
    this.id = rawTableDataTargetLine.id;
    this.charttype = sortedRawTableData[0].charttype;
    this.type = rawTableDataTargetLine.type;
    this.name = rawTableDataTargetLine.name;
    this.title = rawTableDataTargetLine.title;
    this.blockWidth = rawTableDataTargetLine.blockWidth;
    this.offset = rawTableDataTargetLine.offset;
    this.level = rawTableDataTargetLine.level;
    this.parent = rawTableDataTargetLine.parent;

    this.parentNode = parentNode;

    if (this.parentNode && this.charttype === 'Normal Tree') {
      this.normalTreeLevel =
        this.level === 'Auto'
          ? this.parentNode.normalTreeLevel + 1
          : this.level;
    }

    getAllChildLine(sortedRawTableData, rawTableDataTargetLine).forEach(
      (currentLineData) => {
        const childNode = new Node(sortedRawTableData, currentLineData, this);
        this.childNodeList.push(childNode);
      },
    );
  }

  static isLeafNode(node) {
    return node.childNodeList.length === 0 ? true : false;
  }
  static isChildNode(node) {
    return node.parentNode && !Node.isLeafNode(node);
  }
}

const getColorByNode = (node) => {
  if (node.type === 'Organization' && node.parentNode) {
    return '#FFB600';
  } else if (node.type === 'Organization' && !node.parentNode) {
    return '#0089EB';
  }
  return '#B3DCF9';
};

const getNodeHangingStyle = (node) => {
  if (node.charttype === 'Normal Tree') {
    return 'normal';
  }

  let hasGrandChild = false;

  if (Node.isChildNode(node) && node.type === 'Organization') {
    node.childNodeList.forEach((c) => {
      if (c.childNodeList.length !== 0) {
        hasGrandChild = true;
      }
    });
    if (!hasGrandChild) {
      return 'hanging';
    }
  }
  return 'normal';
};

const createOptionNode = (node) => {
  const result = {
    // id: node.id,
    title: node.title,
    name: node.name,
    id: node.name,
    color: getColorByNode(node),
    // width: node.width,
    // height: node.height,
    offset: node.offset,
  };

  if (node.charttype !== 'Normal Tree') {
    // result.offset = node.offset;
    // result.width = node.width;
    if (node.blockWidth) {
      result.width = Number(node.blockWidth);
    }
    result.layout = getNodeHangingStyle(node);
    // if (node.level !== 'Auto') {
    //   result.level = node.level;
    // }
  } else {
    if (node.blockWidth) {
      result.width = Number(node.blockWidth);
    }
    result.level =
      node.charttype === 'Normal Tree'
        ? node.normalTreeLevel - 1
        : node.verticalOrgMemberListlevel;
  }

  return result;
};

const createOptionrelation = (node) =>
  // return [node.parentNode.id, node.id];
  [node.parentNode.name, node.name];
const bfsTree = (node) => {
  const nodes = [];
  const relations = [];
  let maxLevel = 0;
  const stack = [];

  if (node) {
    stack.push(node);
    while (stack.length) {
      const currentNode = stack.shift();
      const childNodeList = currentNode.childNodeList;

      nodes.push(createOptionNode(currentNode));

      if (currentNode.parentNode) {
        relations.push(createOptionrelation(currentNode));
      }

      if (
        maxLevel < currentNode.normalTreeLevel ||
        maxLevel < currentNode.verticalOrgMemberListlevel
      ) {
        maxLevel =
          currentNode.normalTreeLevel > currentNode.verticalOrgMemberListlevel
            ? currentNode.normalTreeLevel
            : currentNode.verticalOrgMemberListlevel;
      }

      for (let i = 0; i < childNodeList.length; i++) {
        stack.push(childNodeList[i]);
      }
    }
  }
  return { nodes, relations, maxLevel };
};

// const formatOrgChartData = (inputData) => {
//   // sort child by parent name
//   const sortedRawTableData = sortRawTableData(inputData);

//   const topNode = new Node(sortedRawTableData, sortedRawTableData[0]);
//   // BFS iterate through tree
//   const { nodes, relations, maxLevel } = bfsTree(topNode);
//   console.log('XXtopNode', topNode);
//   console.log('XXXinputData', inputData);

//   const levels = [];
//   for (let index = 0; index < maxLevel; index++) {
//     levels.push({
//       level: index,
//       // width: 200,
//       // color: '#0089EB',
//       // dataLabels: {
//       //   color: 'white',
//       // },
//     });
//   }

//   return {
//     nodes,
//     levels,
//     relations,
//   };
// };

const getColor = (data, level) => {
  if (data.type === 'Organization' && level === 0) {
    return '#0089EB';
  }

  if (data.type === 'Organization') {
    return '#FFB600';
  }

  return '#B3DCF9';
};

const isHangingNode = (index, inputData) => {
  const currentNode = inputData[index];
  let bottunLeafHierachy = currentNode.hierachy;

  for (let i = index + 1; i < inputData.length; i++) {
    const loopCurrentNode = inputData[i];
    if (loopCurrentNode.hierachy < currentNode.hierachy) {
      break;
    }
    bottunLeafHierachy =
      loopCurrentNode.hierachy > bottunLeafHierachy
        ? loopCurrentNode.hierachy
        : bottunLeafHierachy;
  }

  if (bottunLeafHierachy === currentNode.hierachy + 1) {
    return true;
  }

  return false;
};

const formatOrgChartData = (inputData) => {
  const nodes = [];
  for (let i = 0; i < inputData.length; i++) {
    const element = inputData[i];
    if (i === 0) {
      nodes.push({
        id: element.id,
        title: element.title,
        name: ' ',
        color: getColor(element, element.hierachy),
        dataLabels: {
          color: 'white',
        },
      });
    } else {
      nodes.push({
        id: element.id,
        title: element.title,
        name: element.name,
        color: getColor(element, element.hierachy),
        layout: isHangingNode(i, inputData) ? 'hanging' : 'normal',
      });
    }
  }

  const relations = [];
  for (let i = 1; i < inputData.length; i++) {
    const elementI = inputData[i];

    for (let j = i - 1; j >= 0; j--) {
      const elementJ = inputData[j];
      if (elementJ.hierachy === elementI.hierachy - 1) {
        relations.push([elementJ.id, elementI.id]);
        break;
      }
    }
  }

  if (inputData.length === 1) {
    relations.push([inputData[0].id]);
  }

  const levels = [];
  const maxLevel = Math.max(...inputData.map((o) => o.hierachy));
  for (let index = 0; index < maxLevel; index++) {
    levels.push({
      level: index,
    });
  }

  return {
    nodes,
    levels,
    relations,
  };
};

export const buildOrgChartOption = (inputData) => {
  const { nodes, levels, relations } = formatOrgChartData(inputData);

  const result = {
    plotOptions: {
      organization: {
        borderWidth: 0,
        linkColor: 'white',
      },
    },
    chart: {
      height: levels.size * 80 + 80,
      inverted: true,
      style: {
        fontFamily: 'Helvetica,Arial',
      },
    },
    tooltip: {
      ...defaultToolTip,
      enabled: false,
      outside: true, // outside may cause tooltip offset due to global zooming
      headerFormat: null,
      followPointer: false,
      followTouchMove: false,
    },
    title: {
      text: undefined,
    },

    series: [
      {
        type: 'organization',
        keys: ['from', 'to'],
        data: relations,
        levels,
        color: '#B3DCF9',
        dataLabels: {
          color: '#2d2d2d',
          height: '3.125rem',
          style: {
            fontSize: '1rem',
            fontWeight: '550',
          },
        },
        nodes,
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return result;
};
